/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTagText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaTagText({
  children,
  viewPath = "/DesignSystem/TysiaTag/TysiaTagText",
  display = "flex",
  size = "tiny",
  color,
  cursor,
  text,
  type,
  textTransform,
  style
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtColorsOrange900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.900'
        })
let dtColorsGreen900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsPurple900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.purple.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let colorOrdtColorsNeutral600 = color ?? dtColorsNeutral600
let colorOrdtColorsNeutral6001 = color ?? dtColorsNeutral600
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display={display}
 size={size}
 weight="medium"
 color={type === "grey" && style === "filled" ? dtColorsNeutral900 : type === "blue" && style === "filled" ? dtColorsBlue900 : type === "orange" && style === "filled" ? dtColorsOrange900 : type === "green" && style === "filled" ? dtColorsGreen900 : type === "red" && style === "filled" ? dtColorsRed900 : type === "brand" && style === "filled" ? dtColorsWhite : type === "purple" && style === "filled" ? dtColorsPurple900 : type === "grey" ? dtColorsNeutral900 : type === "blue" ? dtColorsBlue900 : type === "orange" ? dtColorsOrange900 : type === "green" ? dtColorsGreen900 : type === "red" ? dtColorsRed900 : type === "purple" ? dtColorsPurple900 : type === "brand" ? dtColorsNeutral500 : colorOrdtColorsNeutral6001}
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 cursor={cursor}
 text={text}
 type={type}
 textTransform={textTransform}
/>
{children}
</React.Fragment>)
}